import { createActionGroup, props } from '@ngrx/store';
import { ErrorModel } from '@rocksoft/shared';
import { ApplicationConfiguredSetting } from './applications-configured-settings.state';

// ============================================================================
// RESOLVER ACTIONS
// ============================================================================

export const ApplicationsConfiguredSettingsResolverActions = createActionGroup({
  source: 'Applications configured settings resolver',
  events: {
    'Applications configured settings requested': props<{ categoryId: string }>(),
  },
});

// ============================================================================
// API ACTIONS
// ============================================================================

export const ApplicationsConfiguredSettingsApiActions = createActionGroup({
  source: 'Applications configured settings API',
  events: {
    'Applications configured settings loaded': props<{
      categoryId: string;
      settings: ApplicationConfiguredSetting[];
    }>(),
    'Applications configured settings loaded error': props<{ error: ErrorModel }>(),
  },
});
